/** Default Mon–Fri business hours when website scrape finds none. */
export const DEFAULT_WEEKDAY_BUSINESS_HOURS =
  "Monday: 8:00AM-5:00PM Tuesday: 8:00AM-5:00PM Wednesday: 8:00AM-5:00PM Thursday: 8:00AM-5:00PM Friday: 8:00AM-5:00PM Saturday: Closed Sunday: Closed";

export const MARKETPLACE_POWERED_BY_NAME = "Inbound GPT";
export const MARKETPLACE_POWERED_BY_URL = "https://www.easygpt.builders";

export const SITEGLUE_POWERED_BY_NAME = "SiteGlue";
export const SITEGLUE_POWERED_BY_URL = "https://siteglue.ai";

/** Brand-aware Powered By defaults for hire / marketplace onboarding. */
export function getMarketplacePoweredByDefaults(
  brand?: "siteglue" | "inbound_gpt" | null,
): { name: string; url: string } {
  if (brand === "siteglue") {
    return { name: SITEGLUE_POWERED_BY_NAME, url: SITEGLUE_POWERED_BY_URL };
  }
  return { name: MARKETPLACE_POWERED_BY_NAME, url: MARKETPLACE_POWERED_BY_URL };
}

export function getMarketplaceSecondaryTeamMemberEmail(): string {
  return (
    process.env.MARKETPLACE_HIRE_SECONDARY_TEAM_MEMBER_EMAIL?.trim() ||
    "jwanek@easygpt.builders"
  );
}

/** Prefer clean company name over long SEO page titles. */
export function normalizePracticeName(
  practiceName: string | undefined,
  pageTitle: string | undefined,
): string {
  const fromAi = (practiceName ?? "").trim();
  if (fromAi && fromAi.length <= 80 && !fromAi.includes("|")) {
    return fromAi;
  }
  const title = (pageTitle ?? "").trim();
  if (title) {
    if (title.includes("|")) {
      const parts = title.split("|").map((p) => p.trim()).filter(Boolean);
      if (parts.length >= 2) {
        const beforePipe = parts[0]!;
        const afterPipe = parts[parts.length - 1]!;
        const firstLooksLikeSeo =
          /\bin\s+[A-Z]{2}\b/.test(beforePipe) ||
          /\b(services|solutions|company|clinic|center|office|group)\b/i.test(
            beforePipe,
          );
        if (firstLooksLikeSeo && afterPipe.length >= 3) {
          return afterPipe;
        }
      }
    }
    const beforePipe = title.split("|")[0]?.trim();
    if (beforePipe && beforePipe.length >= 2) return beforePipe;
    const beforeDash = title.split(" - ")[0]?.trim();
    if (beforeDash && beforeDash.length >= 2) return beforeDash;
  }
  return fromAi || title || "Our Business";
}

export type GeneratedCtaCluster = {
  ctaQuestion: string;
  qualificationQuestions: string[];
  locationRouting: string;
};

export const DEFAULT_TEAM_HANDOFF_CTAS: GeneratedCtaCluster[] = [
  {
    ctaQuestion: "Connect with Staff",
    qualificationQuestions: [
      "What would you like to discuss with our team?",
      "What's the best way to reach you?",
      "When would be a good time to connect?",
    ],
    locationRouting: "all",
  },
  {
    ctaQuestion: "Request Appointment",
    qualificationQuestions: [
      "What service are you interested in?",
      "What's your preferred date and time?",
      "Do you have any specific requirements or concerns?",
    ],
    locationRouting: "all",
  },
];
